/* eslint-disable no-unused-vars */
/* global $clamp, config */

// Gestion des appels ajax
const $get = (url) => {
	return new Promise((resolve, reject) => {
		const req = new XMLHttpRequest();

		req.onload = () => {
			if (req.readyState === 4 && req.status === 200)
				resolve(JSON.parse(req.response));
			else {
				console.error(`Oups, ça march'te pas 😕 [${url}]`);
				// eslint-disable-next-line prefer-promise-reject-errors
				reject();
			}
		};

		req.open('GET', url);
		req.send();
	});
};

// Toggle
const $toggle = (element, type) => {
	const el = element;
	const { display } = el.ownerDocument.defaultView.getComputedStyle(el, null);

	if (display !== 'none') el.style.display = 'none';
	else el.style.display = type;
};

// A11Y Swiper
const a11y = () => {
	// a11y items duplicate
	const tabindex = -1;
	document.querySelectorAll('li.swiper-slide-duplicate > a').forEach((el) => {
		el.setAttribute('tabindex', tabindex);
	});
	document.querySelectorAll('.swiper-slide-duplicate').forEach((el) => {
		el.setAttribute('aria-hidden', 'true');
		el.classList.add('disabled');
		el.removeAttribute('data-swiper-slide-index');
	});
	// a11y items not:duplicate
	const tabIndex = 0;
	document
		.querySelectorAll('li.swiper-slide:not(.swiper-slide-duplicate) > a')
		.forEach((el) => {
			el.setAttribute('tabindex', tabIndex);
		});
	document
		.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)')
		.forEach((el) => {
			el.setAttribute('aria-hidden', 'false');
			el.removeAttribute('data-swiper-slide-index');
		});
};

// Hide Nav/Swiper
const navSlide = () => {
	const nbSlide = document.querySelectorAll('.swiper-slide').length;
	if (nbSlide <= 2) {
		document.querySelectorAll('.swiper-nav').forEach((nav) => {
			nav.remove();
		});

		document.querySelectorAll('.swiper-wrapper').forEach((wrapper) => {
			wrapper.style.paddingLeft = 0;
		});
	}
};

const polyfillsIE = () => {
	if (/MSIE \d|Trident.*rv:/.test(navigator.userAgent)) {
		// Polyfill forEach ES5
		if (window.NodeList && !NodeList.prototype.forEach) {
			NodeList.prototype.forEach = function (callback, thisArg) {
				thisArg = thisArg || window;
				for (let i = 0; i < this.length; i++) {
					callback.call(thisArg, this[i], i, this);
				}
			};
		}
	}
};

const activeDot = () => {
	// FONCTIONS
	// Lancement de la librairie clamp sur chaque éléments dotdot @see https://github.com/josephschmitt/Clamp.js
	const dotdot = () => {
		document.querySelectorAll('[data-dot]').forEach((element) => {
			const lines = element.getAttribute('data-dot');
			$clamp(element, { clamp: lines });
		});
	};

	const dotP = ($content, $lines) => {
		document.querySelectorAll($content).forEach((element) => {
			element.setAttribute('data-dot', $lines);
		});
		document.querySelectorAll(`${$content}> p`).forEach((element) => {
			element.setAttribute('data-dot', $lines);
		});
		document.querySelectorAll(`${$content}> span`).forEach((element) => {
			element.setAttribute('data-dot', $lines);
		});
	};

	// EVENTS
	const events = () => {
		const obs = new MutationObserver(() => {
			dotdot();
		});

		obs.observe(config.root, {
			childList: true,
		});
	};

	// GO 🚀
	const init = () => {
		dotP('div.card-text', '4');
		dotP('div.gallery', '3');
		dotP('div.rt__grid__result__item h3', '2');
		dotdot();
		events();
	};

	init();
};
